import { render, staticRenderFns } from "./RecentBranches.vue?vue&type=template&id=10e43cd2&scoped=true"
import script from "./RecentBranches.vue?vue&type=script&lang=ts"
export * from "./RecentBranches.vue?vue&type=script&lang=ts"
import style0 from "./RecentBranches.vue?vue&type=style&index=0&id=10e43cd2&prod&scoped=true&lang=css"
import style1 from "./RecentBranches.vue?vue&type=style&index=1&id=10e43cd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e43cd2",
  null
  
)

export default component.exports